module.exports = __webpack_public_path__ + "static/media/message.0d3b2685.svg";